/**
 * État global unique + `sync()` (pattern du prototype, index.html:313, :2067).
 * Pas de store, pas d'observables. `state.ts` ne connaît NI l'UI NI le réseau :
 * `sync` est injecté par `main.ts` (render + netPush).
 */
import type { Diff, GameEngine, PuzzleBase } from '@ordre-cache/shared';
import { GAMES } from './engines';

export interface AppState {
  screen: 'home' | 'hub' | 'play';
  diff: Diff;
  sizeIdx: number;
  game: number;
  defi: number;
  puz: PuzzleBase | null;
}

export const state: AppState = {
  screen: 'home',
  diff: 1,
  sizeIdx: 1,
  game: 0,
  defi: 0,
  puz: null,
};

export { GAMES };

/** Moteur courant (index.html:1827). */
export const G = (): GameEngine => GAMES[state.game];
/** Taille de grille courante (index.html:1828). */
export const curN = (): number => G().sizes[state.sizeIdx];

let syncImpl: () => void = () => {};
export function setSync(fn: () => void): void {
  syncImpl = fn;
}
/** render() + netPush() (index.html:2067). */
export function sync(): void {
  syncImpl();
}
